"use client";

import Image from "next/image";
import Link from "next/link";

import { OPEN_BANNER_EVENT } from "@/lib/consent";
import HipaaComplianceBadge from "./HipaaComplianceBadge";

export default function ModernFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative overflow-hidden bg-[#091661] text-white">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(60% 80% at 80% 20%, rgba(255,255,255,.08), transparent 70%)",
        }}
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 bottom-0 h-[300px] opacity-30 md:h-[500px]"
        style={{
          backgroundImage: "url('/footer/footer-pattern.png')",
          backgroundPosition: "bottom center",
          backgroundRepeat: "repeat-x",
          backgroundSize: "auto 75%",
        }}
      />

      <div className="relative z-10 px-6">
        <div className="mx-auto max-w-5xl">
          <div className="flex flex-col gap-12 py-16 lg:flex-row lg:items-start lg:justify-between">
            <div>
              <Image
                src="/Logotype_Horizontal_Dark_BG@2x.png"
                alt="Logical Health"
                width={250}
                height={50}
                className="h-12 w-auto"
              />

              <div className="mt-6 flex flex-wrap items-center gap-4">
                <a
                  href="https://linkedin.com/company/logical-health"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rounded-lg bg-white/10 p-2.5 transition-colors hover:bg-white/20"
                  aria-label="LinkedIn"
                >
                  <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                  </svg>
                </a>
                <a
                  href="https://www.youtube.com/@TheLogicalHealth"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rounded-lg bg-white/10 p-2.5 transition-colors hover:bg-white/20"
                  aria-label="YouTube"
                >
                  <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                  </svg>
                </a>
                <HipaaComplianceBadge />
                <Image
                  src="/soc2-badge.png"
                  alt="AICPA SOC 2 badge"
                  width={359}
                  height={357}
                  className="h-12 w-auto"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 gap-y-8 sm:grid-cols-2 sm:gap-x-16">
              <div>
                <h3 className="mb-4 text-base font-bold text-white!">Company</h3>
                <ul className="space-y-3">
                  <li><Link href="/trust" className="text-white/80 transition-colors hover:text-white">Trust Center</Link></li>
                  <li><Link href="/team" className="text-white/80 transition-colors hover:text-white">Team</Link></li>
                  <li><Link href="/blog" className="text-white/80 transition-colors hover:text-white">Blog</Link></li>
                </ul>
              </div>
              <div>
                <h3 className="mb-4 text-base font-bold text-white!">Contact</h3>
                <ul className="space-y-3 text-white/80">
                  <li>Logical Health, Inc.</li>
                  <li><a href="mailto:hello@logical.health" className="break-words transition-colors hover:text-white">hello@logical.health</a></li>
                  <li><a href="tel:+14158004642" className="transition-colors hover:text-white">+1 415-800-4642</a></li>
                  <li>1509 Pershing Drive, Unit F<br />San Francisco, CA 94129, USA</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center justify-between gap-4 border-t border-white/15 pb-20 pt-6 text-sm md:flex-row">
            <p className="text-white/80">© {currentYear} Logical Health, Inc. All rights reserved.</p>
            <div className="flex flex-wrap justify-center gap-4 sm:gap-6 md:justify-end">
              <Link href="/legal#privacy-policy" className="text-white/80 transition-colors hover:text-white">Privacy Policy</Link>
              <Link href="/legal#terms-of-service" className="text-white/80 transition-colors hover:text-white">Terms of Service</Link>
              <Link href="/accessibility" className="text-white/80 transition-colors hover:text-white">Accessibility</Link>
              <button
                type="button"
                onClick={() => window.dispatchEvent(new CustomEvent(OPEN_BANNER_EVENT))}
                className="text-white/80 transition-colors hover:text-white"
              >
                Cookie Settings
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
